const state = {
  // 新消息数量
  newMsgNum: 0,
  // 新消息内容
  newMsg: '',
  dateTime: '',
  socket: null
}

const mutations = {
  // 获取新消息数量
  GET_NEW_MSG_NUM: (state, num) => {
    state.newMsgNum = num
  },
  // 获取新消息内容
  GET_NEW_MSG: (state, msg) => {
    state.newMsg = msg
  },
  // 获取新消息时间
  GET_NEW_MSG_TIME: (state, time) => {
    state.dateTime = time
  },
  // 存放websocket
  SOCKET: (state, socket) => {
    state.socket = socket
  }
}

const actions = {
  // 开启websocket
  createSocket({ commit, state }, data) {
    const ws = new WebSocket(process.env.VUE_APP_WS_API + data)
    commit('SOCKET', ws)
  },
  listenForMessages({ state, commit }, that) {
    state.socket.onopen = () => {
    }
    state.socket.onmessage = event => {
      const message = JSON.parse(event.data)
      // msg.datetime 时间戳转换成日期
      // message.total 转成数字
      commit('GET_NEW_MSG_NUM', message.total)
      if (Number(message.total) > 0) {
        const date = new Date(message.datetime)
        commit('GET_NEW_MSG', message.title)
        commit('GET_NEW_MSG_TIME', date)
        // 触发组件名为MsgCenter上的一个方法
        that.$bus.$emit('getNewMsgList')
        that.$notify.success({
          // title: 'Info',
          title: `${message.title}`,
          // message: `${message.title}`,
          duration: 3000,
          onClick: () => {
            that.$router.push({ name: 'MsgCenter' })
          }
        })
      }
    }
    state.socket.onclose = () => {
    }
  },
  // 关闭websocket
  closeSocket({ state, commit }) {
    if (state.socket) {
      state.socket.close()
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

